<template>
  <div class="position-relative" ref="dropdown">
    <!-- Trigger Button -->
    <button
        class="btn text-white d-flex align-items-center gap-2"
        @click="toggleDropdown"
        aria-haspopup="true"
        :aria-expanded="showDropdown"
    >
      <CIcon name="cil-user" class="me-2 mr-2" size="lg" />
      <div class="text-start">
        <div class="fw-bold mr-2">{{ user.name || 'User' }}</div>
      </div>
      <CIcon name="cil-caret-bottom" class="ms-2" />
    </button>

    <!-- Dropdown Menu with transition -->
    <transition name="fade">
      <div
          v-if="showDropdown"
          class="dropdown-menu show mt-2 p-2 shadow"
          style="right: 0; left: auto; border-radius: 0.5rem; min-width: 180px; position: absolute;"
      >
        <a
            href="#"
            class="dropdown-item text-danger d-flex align-items-center fw-bold"
            @click.stop.prevent="logout"
        >
          <CIcon name="cil-loop-circular" class="me-2" />
          Logout
        </a>
      </div>
    </transition>
  </div>
</template>

<script>
import { CIcon } from '@coreui/vue';
import { mapGetters } from 'vuex';

export default {
  name: 'TheHeaderDropdownAccnt',
  components: { CIcon },
  data() {
    return {
      showDropdown: false
    };
  },
  computed: {
    ...mapGetters({ user: 'auth/user' })
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    logout() {
      this.$store.dispatch('auth/signOut');
    },
    handleClickOutside(event) {
      if (!this.$refs.dropdown.contains(event.target)) {
        this.showDropdown = false;
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<style scoped>
.dropdown-menu {
  z-index: 9999;
  background-color: #fff;
  border: 1px solid #dee2e6;
  padding: 0.5rem;
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
